import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'utilities';
import { useAuth } from 'auth_context';

import { Loading, OrgPortalButton } from 'components';
import OrganizationInfo from 'pages/secure/org_info';

class OrganizationPortalPage extends Component {
	constructor(props) {
		super(props);

		this.state = {
			loading: true,
			org_data: {},
		};
	}

	componentDidMount() {
		if (!this.props.auth.user) {
			return;
		}
		// Pull fresh membership/approval state so a newly-approved user sees their
		// org panel unlock without having to log out and back in.
		this.props.auth.refreshUser?.();
	}

	render() {
		const orgs = this.props.auth.user?.orgs || [];
		const org_names = orgs.map((o, i) => (
			<React.Fragment key={o.id}>
				<Link to={`/org_info/${o.id}`} className="org-name-link">
					{o.name}
				</Link>
				{i < orgs.length - 1 ? ', ' : ''}
			</React.Fragment>
		));
		const admin = this.props.auth.user?.is_admin || false;

		const pending_orgs = this.props.auth.user?.pending_orgs || [];
		const pending_ids = new Set(pending_orgs.map(o => o.id));
		const approved_orgs = orgs.filter(o => !pending_ids.has(o.id));

		const user_buttons = [];
		// Only approved members can review join requests for their org.
		if (approved_orgs.length > 0 && !admin) {
			user_buttons.push(
				<OrgPortalButton
					key="join-requests"
					label="Join Requests"
					onClick={() => this.props.navigate('/join_requests')}
				/>
			);
		}

		const admin_buttons = admin
			? [
					<OrgPortalButton key="edit-orgs" label="View / Edit Orgs" variant="admin" onClick={() => this.props.navigate('/admin/orgs')} />,
					<OrgPortalButton key="edit-user" label="View / Edit Users" variant="admin" onClick={() => this.props.navigate('/admin/users')} />,
					<OrgPortalButton key="join-requests-admin" label="Join Requests" variant="admin" onClick={() => this.props.navigate('/join_requests')} />,
				]
			: [];

		return (
			<div className="portal-welcome-splash-container">
				<div className="portal-welcome-splash-text">Welcome {this.props.auth.user.name} :)</div>
				<div className="portal-info-table">
					<span className="portal-info-label">Your Organization:</span>
					<span className="portal-info-value">{orgs.length > 0 ? org_names : '—'}</span>
					{pending_orgs.length > 0 && (
						<>
							<span className="portal-info-label">Pending approval:</span>
							<span className="portal-info-value">
								{pending_orgs.map(o => o.name).join(', ')}
							</span>
						</>
					)}
					{admin && (
						<>
							<span className="portal-info-label">Role:</span>
							<span className="portal-info-value">Admin</span>
						</>
					)}
				</div>

				{admin_buttons.length > 0 && (
					<div className="portal-button-section">
						<div className="portal-button-section-label">Admin</div>
						<div className="portal-button-grid">{admin_buttons}</div>
					</div>
				)}

				{user_buttons.length > 0 && (
					<div className="portal-button-section">
						<div className="portal-button-section-label">My Portal</div>
						<div className="portal-button-grid">{user_buttons}</div>
					</div>
				)}

				{!admin && orgs.map(o => (
					<div key={o.id} className="portal-org-panel">
						<OrganizationInfo embedded orgId={o.id} />
					</div>
				))}
			</div>
		);
	}
}

const OrganizationPortal = props => {
	const auth = useAuth();
	return <OrganizationPortalPage {...props} auth={auth} />;
};

export default withRouter(OrganizationPortal);
